module.exports = __webpack_public_path__ + "img/img_floating_banner.aceacfc7.gif";